// extracted by mini-css-extract-plugin
module.exports = {"tooltipBox":"Tooltip_tooltipBox__wIedo","tooltipButton":"Tooltip_tooltipButton__RGT4w","arrow":"Tooltip_arrow__Qa4dI"};